import { render, staticRenderFns } from "./CookieLaw.vue?vue&type=template&id=deec36de&scoped=true&"
import script from "./CookieLaw.vue?vue&type=script&lang=js&"
export * from "./CookieLaw.vue?vue&type=script&lang=js&"
import style0 from "./CookieLaw.vue?vue&type=style&index=0&id=deec36de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deec36de",
  null
  
)

component.options.__file = "CookieLaw.vue"
export default component.exports